import { Controller, useFormContext } from 'react-hook-form'

import {
  PickerFormControl,
  PickerFormControlTagProps,
} from '../EntityPicker/PickerFormControl.js'
import { FormFieldProps } from './typings.js'

export function FormTagPicker({
  name,
  validation,
  value: fieldValue,
  onChange: fieldOnChange,
  ...rest
}: FormFieldProps<PickerFormControlTagProps>) {
  const { control } = useFormContext()

  return (
    <Controller
      control={control}
      name={name}
      rules={validation}
      render={({ field: { onChange, value }, fieldState: { error } }) => (
        <PickerFormControl.TagPicker
          {...rest}
          name={name}
          invalid={!!error?.message}
          error={error?.message}
          value={fieldValue ?? value}
          onChange={value => {
            onChange(value)
            if (typeof fieldOnChange === 'function') {
              fieldOnChange(value)
            }
          }}
        />
      )}
    />
  )
}
